// removed by extract-text-webpack-plugin
module.exports = {"container":"_2uN-gr9GW3wM0TdcFxHiFi"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Sign/Prepare/Field/Menu/TextSize/styles.css
// module id = 3097
// module chunks = 0